module.exports = "option {\n  display: none; }\n\n.scroll-v {\n  max-height: 60vh;\n  min-height: 60vh;\n  overflow-y: auto !important;\n  overflow-x: auto !important; }\n\n.bg-white {\n  background: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal-select/modal-select.component.scss
// module id = ./src/app/shared/modal-select/modal-select.component.scss
// module chunks = main